<template>
  <div class="g-ft f-clearfix">
    <div class="container" style="display: block">
      <div class="g-ftl">
        <img :src="imgUrl + maessage.footer_logo" :alt="maessage.title" />
      </div>
      <div class="g-ftc">
        <div class="go-us">
          <a href="/usIndex?activeName=1" target="_blank">关于我们</a>
          &nbsp;|&nbsp;
          <a href="/usIndex?activeName=2" target="_blank">联系方式</a>
          &nbsp;|&nbsp;
          <a href="/usIndex?activeName=3" target="_blank">帮助中心</a>
        </div>
        <ul class="con-link" v-show="linkUrl.length > 0">
          <li>友情链接：</li>
          <li v-for="(item, index) in linkUrl" :key="index">
            <a :href="`${item.link}`" target="_blank">{{ item.name }}</a>
            <span v-if="index != linkUrl.length - 1">&nbsp;&nbsp;&nbsp;|</span>
          </li>
        </ul>

        <div style="display: flex;align-items: center">
          {{ maessage.copyright }}&nbsp;&nbsp;&nbsp;&nbsp;
          版权所有：南京智慧在线教育科技有限公司&nbsp;&nbsp;|&nbsp;&nbsp;
          <a style="display: flex;align-items: center" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32010402001344" target="_blank" class="icp-a">
              <img
                  src="../../public/images/icon_icp.jpg"
                  alt=""
                  style="width: 14px; height: 14px; margin-right: 4px"
              />
            <span style="">{{ maessage.ICP }}</span>
          </a>
          <a href="https://beian.miit.gov.cn/" target="_blank" class="icp-a">
            &nbsp;&nbsp;苏ICP备2020068813号
          </a>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setTimeout } from "timers";
export default {
  name: "Footer",
  data () {
    return {
      imgUrl: this.$setting.fdsDomain,
      linkUrl: [],
      maessage: {},
    };
  },
  mounted () {
    this.getProtal();
  },

  methods: {
    getProtal () {
      setTimeout(() => {
        let protalMsg = JSON.parse(localStorage.getItem("maessage"));
        let protalLink = JSON.parse(localStorage.getItem("msgLinks"));
        this.maessage = protalMsg.content;
        this.linkUrl = protalLink.links;
      }, 300);
    },
  },
};
</script>

<style lang="scss">
.con-link {
  list-style: none;
  padding: 0;
  margin: 0;
  color: #888;
  li {
    display: inline-block;
    color: #888;
    line-height: 25px;
    margin-left: 10px;
    a {
      color: #888;
      &:hover {
        color: #dedede;
      }
    }
    &:first-child {
      margin-left: 0;
    }
  }
}
.go-us {
  a {
    color: #888;
    &:hover {
      color: #dedede;
    }
  }
}
.icp-a {
  color: #888;
  &:hover {
    color: #dedede;
  }
}
</style>
